import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Brand(props) {
    return (
        <SvgIcon {...props} fill="none">
            <path d="M7.82337 1.33257C7.89857 1.19098 8.10144 1.19098 8.17663 1.33257L10.2554 5.24645C10.2843 5.30088 10.3367 5.33894 10.3974 5.34961L14.7621 6.11715C14.9199 6.14492 14.9826 6.33786 14.8712 6.45313L11.7913 9.63958C11.7484 9.68389 11.7284 9.74548 11.737 9.80651L12.3558 14.1948C12.3782 14.3535 12.2141 14.4727 12.07 14.4024L8.08776 12.4579C8.03238 12.4308 7.96762 12.4308 7.91224 12.4579L3.92999 14.4024C3.78593 14.4727 3.62181 14.3535 3.64419 14.1948L4.26298 9.80651C4.27158 9.74548 4.25157 9.68389 4.20874 9.63958L1.12878 6.45313C1.01737 6.33786 1.08006 6.14492 1.23795 6.11715L5.60264 5.34961C5.66333 5.33894 5.71572 5.30088 5.74463 5.24645L7.82337 1.33257Z" stroke="black" strokeWidth="2" />
        </SvgIcon>
    );
}

Brand.defaultProps = {
    viewBox: '0 0 18 18'
};

export default Brand;

